import {
  getCookie,
  setCookie,
  sendAmplitudeIdentifyEvent,
  getCart,
  setCartAttributes,
} from "@theme/utilities";
(async function SocialladderModule() {
  const socialladderenabled = window.BODi.configs.socialladder.enabled;
  if (!socialladderenabled) return;

  const API_URL = window.BODi.configs.socialladder.apiUrl;
  const namespace = "socialladder";
  const cookieName = "bodi-socialladder-ambassador-id";
  const cookieMaxAge = 30 * 24 * 60 * 60; // 30 days
  const cookieDomain = location.hostname.endsWith("bodi.com")
    ? location.hostname.split(".").slice(1).join(".")
    : location.hostname;
  const cartAttributeName = "socialladderambassadorId";
  const currentUrl = new URL(window.location.href);
  const ambassadorID = currentUrl.searchParams.get("ambassadorID");
  const inviteToBuyGUID = getCookie(cookieName);

  /**
   * if the ambassadorID is present in the URL,
   * 1. exchange it to an inviteToBuyGUID
   * 2. send the analytics event
   * 3. update the cookie
   * 4. update the cart with the inviteToBuyGUID
   */
  if (ambassadorID) {
    const inviteToBuyGUID = await getInviteToBuyGUID(ambassadorID);
    if (inviteToBuyGUID) {
      sendAmplitudeIdentifyEvent({ "socialladder ambassador id": inviteToBuyGUID });
      setCookie(cookieName, inviteToBuyGUID, { maxAge: cookieMaxAge, domain: cookieDomain });
      setInviteToBuyGUIDToCart(inviteToBuyGUID);
    }
    return;
  }

  /**
   * otherwise, if the inviteToBuyGUID is present in the cookie and is different from the cart,
   * 1. send the analytics event
   * 2. update the cart with the inviteToBuyGUID
   */
  if (inviteToBuyGUID) {
    console.info(`[${namespace}] - InviteToBuyGUID found in cookie`, { inviteToBuyGUID });
    sendAmplitudeIdentifyEvent({ "socialladder ambassador id": inviteToBuyGUID });
    const cart = await getCart();
    if (inviteToBuyGUID !== cart.attributes[cartAttributeName]) {
      setInviteToBuyGUIDToCart(inviteToBuyGUID);
    } else {
      console.info(`[${namespace}] - InviteToBuyGUID is already set to cart`, { inviteToBuyGUID });
    }
    return;
  }

  /**
   * Exchange an ambassadorID to an inviteToBuyGUID
   * @param {string} ambassadorID
   */
  async function getInviteToBuyGUID(ambassadorID) {
    try {
      console.info(`[${namespace}] - Getting InviteToBuyGUID for ambassadorID`, { ambassadorID });
      const url = new URL(`${API_URL}/campaign/processinvitetobuy`);
      url.searchParams.append("sltrackid", ambassadorID);
      const response = await fetch(url);
      const data = await response.json();

      if (!data?.InviteToBuyGUID) {
        console.error(`[${namespace}] - No InviteToBuyGUID received from API`, {
          ambassadorID,
          data,
        });
        return null;
      }

      console.info(`[${namespace}] - InviteToBuyGUID received from API`, { ambassadorID, data });
      return data.InviteToBuyGUID;
    } catch (error) {
      console.error(`[${namespace}] - Exchange ambassadorID to InviteToBuyGUID failed`, {
        ambassadorID,
        error,
      });
      return null;
    }
  }

  /**
   * Set the InviteToBuyGUID to the cart
   * @param {string} inviteToBuyGUID
   */
  async function setInviteToBuyGUIDToCart(inviteToBuyGUID) {
    try {
      console.info(`[${namespace}] - Setting InviteToBuyGUID to cart`, { inviteToBuyGUID });
      await setCartAttributes({ [cartAttributeName]: inviteToBuyGUID });
      console.info(`[${namespace}] - InviteToBuyGUID set to cart successfully`, {
        inviteToBuyGUID,
      });
    } catch (error) {
      console.error(`[${namespace}] - Set InviteToBuyGUID to cart failed`, {
        inviteToBuyGUID,
        error,
      });
    }
  }
})();
